import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage() {
  return request.send({
    url: `/pmy/sys/role/list`,
    method: "get",
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/role`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/role`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(roleId) {
  return request.send({
    url: `/pmy/sys/role?roleId=${roleId}`,
    method: "delete",
  });
}
// 详情
export function detailInfo(roleId) {
  return request.send({
    url: `/pmy/sys/role?roleId=${roleId}`,
    method: "get",
  });
}

// 获取可操作权限
export function getRoleMenu(roleId) {
  return request.send({
    url: `/pmy/sys/role/menus?roleId=${roleId}`,
    method: "get",
  });
}

// 保存角色权限
export function savePermissions(data) {
  return request.send({
    url: `/pmy/sys/role/menus`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
